import { observable } from '@/libs/state'
import { defaultUserPreferences } from './domain/user-preferences'
import type { UserPreferences } from './domain/user-preferences'

const userPreferences$ = observable<UserPreferences>(defaultUserPreferences)

export { userPreferences$ }
